import(/* webpackMode: "eager", webpackExports: ["AdminNavigation"] */ "/carbonara/apps/webapp/src/app/(authenticated)/(admin)/_components/AdminNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AddOrganizationItem"] */ "/carbonara/apps/webapp/src/components/Header/Menu/AddOrganizationItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChangeLanguageItem"] */ "/carbonara/apps/webapp/src/components/Header/Menu/ChangeLanguageItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutButton"] */ "/carbonara/apps/webapp/src/components/Header/Menu/LogoutButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationItem"] */ "/carbonara/apps/webapp/src/components/Header/Menu/OrganizationItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationSettingsItem"] */ "/carbonara/apps/webapp/src/components/Header/Menu/OrganizationSettingsItem.tsx");
;
import(/* webpackMode: "eager" */ "/carbonara/apps/webapp/src/components/I18NText.tsx");
;
import(/* webpackMode: "eager" */ "/carbonara/apps/webapp/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/carbonara/apps/webapp/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["formatNumber","FormattedNumber"] */ "/carbonara/apps/webapp/src/lib/formatNumber.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipArrow"] */ "/carbonara/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/carbonara/node_modules/next/dist/client/app-dir/link.js");
